// extracted by mini-css-extract-plugin
export default {"parent":"supportForm_parent__OhB2M","parentFormSubmit":"supportForm_parentFormSubmit__1+uis","parentDescription":"supportForm_parentDescription__aB8kh"};